const apiUrl = 'https://collectoria.bg';

export const environment = {
  production: true,
  enableDebug: false,
  applicationDomain: 'https://collectoria.bg',
  apiCoreUrl: `${apiUrl}/api/core`,
  apiAccountUrl: `${apiUrl}/api/account`,
  apiNomenclatureUrl: `${apiUrl}/api/nomenclature`,
  apiImageAdUrl: `${apiUrl}/api/image/adImage`,
  apiImageUserProfileUrl: `${apiUrl}/api/image/userProfileImage`,
  apiImageDefaultUserProfileUrl: `https://collectoria.bg/assets/default-user-profile-image.webp`,
  adHubUrl: `${apiUrl}/hub/ad`,
  userHubUrl: `${apiUrl}/hub/user`,
  googleAuthUri: 'https://accounts.google.com/o/oauth2/v2/auth',
  googleClientId: '1010771078066-snme5gl7fukrdnqhlpmo36n27c8t6tmi.apps.googleusercontent.com',
  googleRedirectUri: 'https://collectoria.bg/account/login'
}
